// (function ($) {
//   'use strict';

//   /* =========================================================
//      ISSUE 4
//      Mobile menu submenus cannot be opened with keyboard
//      ========================================================= */
//   function injectMobileToggles() {
//     $('#mobile-menu a.tmenu_item_link[aria-haspopup="true"]').each(function (i) {
//       var $link = $(this);

//       // Find submenu before marking the link as processed.
//       var $sub = $link.siblings('.tmenu_submenu').first();

//       if (!$sub.length) {
//         $sub = $link.parent().find('.tmenu_submenu').first();
//       }

//       if (!$sub.length) {
//         return;
//       }

//       // Do not create duplicate buttons.
//       if ($link.next('.mobile-menu__a11y-toggle').length) {
//         return;
//       }

//       var subId = $sub.attr('id');

//       if (!subId) {
//         subId = 'mobile-submenu-' + Date.now() + '-' + i;
//         $sub.attr('id', subId);
//       }

//       // The link remains a normal navigation link.
//       $link.removeAttr('aria-haspopup aria-expanded');

//       var menuName = $.trim($link.text()) || 'menu';

//       var $button = $('<button>', {
//         type: 'button',
//         'class': 'mobile-menu__a11y-toggle tmenu-a11y-toggle',
//         'aria-expanded': 'false',
//         'aria-controls': subId,
//         'aria-label': 'Expand ' + menuName + ' submenu'
//       });

//       $button.insertAfter($link);

//       // Make the initial collapsed state explicit.
//       $sub.attr({
//         'aria-hidden': 'true'
//       });
//     });
//   }

//   function initMobileMenuAccessibility() {
//     injectMobileToggles();

//     // qikify may render the menu after the initial page load.
//     $(document).on(
//       'click',
//       '.header__mobile-nav-toggle',
//       function () {
//         setTimeout(injectMobileToggles, 100);
//         setTimeout(injectMobileToggles, 300);
//         setTimeout(injectMobileToggles, 700);
//       }
//     );

//     // Keyboard and mouse activation both use the native button.
//     $(document).on(
//       'click',
//       '.mobile-menu__a11y-toggle',
//       function (e) {
//         e.preventDefault();

//         var $button = $(this);
//         var $link = $button.prev('a.tmenu_item_link');

//         var subId = $button.attr('aria-controls');
//         var $submenu = $('#' + CSS.escape(subId));

//         if (!$submenu.length) {
//           return;
//         }

//         var isOpen = $button.attr('aria-expanded') === 'true';
//         var newState = !isOpen;

//         var name = ($button.attr('aria-label') || '')
//           .replace(/^(Expand|Collapse)\s+/i, '');

//         $button.attr({
//           'aria-expanded': String(newState),
//           'aria-label': (newState ? 'Collapse ' : 'Expand ') + name
//         });

//         $submenu
//           .toggleClass('is-open', newState)
//           .attr('aria-hidden', String(!newState));

//         /*
//          * Keep qikify's own menu state synchronized.
//          * Trigger this only when the link exists.
//          */
//         if ($link.length) {
//           $link.trigger('tmenu:toggle');
//         }
//       }
//     );
//   }


//   /* =========================================================
//      ISSUE 5
//      Non-functional "column heading" links in mega menus
//      ========================================================= */
//   function fixMegaMenuHeadings() {
//     $(
//       '.tmenu_submenu a.tmenu_item_link[tmenu-disabled-link], ' +
//       '.tmenu_submenu a.tmenu_item_link[href="javascript:;"]'
//     ).each(function () {
//       var $link = $(this);

//       // Prevent duplicate replacement.
//       if ($link.hasClass('tmenu_heading') || $link.next('.tmenu_heading').length) {
//         return;
//       }

//       var text = $.trim($link.text());

//       if (!text) {
//         return;
//       }

//       $('<div>', {
//         'class': ($link.attr('class') || '') + ' tmenu_heading',
//         role: 'heading',
//         'aria-level': '3',
//         text: text
//       }).replaceWith($link);

//       // replaceWith above is intentionally handled directly below
//     });
//   }


//   /* =========================================================
//      ISSUE 6
//      Focus rings must be visible for keyboard users
//      ========================================================= */
//   function initKeyboardFocus() {
//     var pointerDown = false;

//     $(document)
//       .on('pointerdown mousedown touchstart', function () {
//         pointerDown = true;
//         $('body').removeClass('is-tabbing');
//       })

//       .on('keydown', function (e) {
//         // Keyboard navigation.
//         if (
//           e.key === 'Tab' ||
//           e.key === 'ArrowUp' ||
//           e.key === 'ArrowDown' ||
//           e.key === 'ArrowLeft' ||
//           e.key === 'ArrowRight'
//         ) {
//           pointerDown = false;
//           $('body').addClass('is-tabbing');
//         }
//       })

//       .on('focusin', function (e) {
//         if (!pointerDown) {
//           $('body').addClass('is-tabbing');
//           $(e.target).addClass('is-kbd-focus');
//         }
//       })

//       .on('focusout', function (e) {
//         $(e.target).removeClass('is-kbd-focus');
//       });
//   }


//   /* =========================================================
//      ISSUE 7
//      Escape must close predictive-search results
//      ========================================================= */
//   function initSearchEscape() {
//     $(document).on(
//       'keydown',
//       '.search-bar__input, .search-bar__results a',
//       function (e) {
//         if (e.key !== 'Escape' && e.key !== 'Esc' && e.keyCode !== 27) {
//           return;
//         }

//         e.preventDefault();
//         e.stopPropagation();

//         var $input = $('.search-bar__input').first();
//         var $results = $('.search-bar__results').first();

//         $results
//           .empty()
//           .attr('hidden', true);

//         $input
//           .attr('aria-expanded', 'false')
//           .removeAttr('aria-activedescendant')
//           .trigger('focus');

//         $('#search-status').text('');
//       }
//     );
//   }


//   /* =========================================================
//      ISSUE 8
//      Space on review carousel arrows must not scroll page
//      ========================================================= */
//   function initReviewCarouselKeyboard() {
//     var selector =
//       '.jdgm-carousel__left-arrow, ' +
//       '.jdgm-carousel__right-arrow';

//     $(document).on('keydown', selector, function (e) {
//       if (
//         e.key === ' ' ||
//         e.key === 'Spacebar' ||
//         e.keyCode === 32
//       ) {
//         e.preventDefault();
//         e.stopPropagation();

//         $(this).trigger('click');
//       }
//     });
//   }


//   /* =========================================================
//      ISSUE 10
//      Brand-logo links without accessible names
//      ========================================================= */
//   function fixBrandLogoNames() {
//     var selector =
//       '#tmenu-submenu-5 a, ' +
//       '.quick-links__link, ' +
//       '.tmenu_submenu a:has(img[alt=""])';

//     $(selector).each(function () {
//       var $link = $(this);

//       // Existing accessible name.
//       if ($.trim($link.attr('aria-label') || '')) {
//         return;
//       }

//       var $image = $link.find('img').first();

//       var imageAlt = $.trim($image.attr('alt') || '');

//       /*
//        * Visible text can provide the accessible name.
//        */
//       var visibleText = $.trim(
//         $link
//           .clone()
//           .find('style, script')
//           .remove()
//           .end()
//           .text()
//       );

//       if (visibleText) {
//         return;
//       }

//       var name = imageAlt;

//       /*
//        * If the image has no useful alt, derive a name from
//        * the URL as a last resort.
//        */
//       if (!name) {
//         var href = ($link.attr('href') || '')
//           .split('?')[0]
//           .replace(/\/+$/, '');

//         var parts = href.split('/').filter(Boolean);
//         var handle = parts.length ? parts[parts.length - 1] : '';

//         name = handle
//           .replace(/[-_]+/g, ' ')
//           .replace(/\b\w/g, function (c) {
//             return c.toUpperCase();
//           });
//       }

//       if (!name) {
//         return;
//       }

//       $link.attr('aria-label', 'Shop ' + name);

//       /*
//        * The link now has its accessible name, so the logo image
//        * itself should not be announced separately.
//        */
//       if ($image.length) {
//         $image.attr({
//           alt: '',
//           role: 'presentation'
//         });
//       }
//     });
//   }


//   /* =========================================================
//      ISSUE 11
//      Mobile hero images inherit desktop image alternative text
//      ========================================================= */
//   function fixMobileHeroAltText() {
//     $('.slideshow__slide').each(function () {
//       var $slide = $(this);

//       var desktopAlt = $.trim(
//         $slide
//           .find('.hidden-phone img')
//           .first()
//           .attr('alt') || ''
//       );

//       var $mobile = $slide
//         .find('.hidden-tablet-and-up img')
//         .first();

//       if (
//         desktopAlt &&
//         $mobile.length &&
//         !$.trim($mobile.attr('alt') || '')
//       ) {
//         $mobile.attr('alt', desktopAlt);
//       }
//     });
//   }


//   /* =========================================================
//      ISSUE 12
//      Search toggle aria-expanded must match actual state
//      ========================================================= */
//   function initSearchToggle() {
//     var $buttons = $('[data-action="toggle-search"]');
//     var $header = $('.header');
//     var $searchBar = $('.search-bar');
//     var $input = $('.search-bar__input').first();

//     if (!$buttons.length || !$header.length) {
//       return;
//     }

//     var searchId = 'header-search-bar';

//     $searchBar.attr('id', searchId);

//     $buttons.each(function () {
//       var $button = $(this);

//       $button.attr({
//         role: 'button',
//         'aria-controls': searchId
//       });
//     });

//     function syncSearchState() {
//       var isOpen =
//         $header.hasClass('header--search-expanded') ||
//         $searchBar.is(':visible');

//       $buttons.attr({
//         'aria-expanded': String(isOpen),
//         'aria-label': isOpen
//           ? 'Close search'
//           : 'Open search'
//       });

//       if (isOpen && $input.length) {
//         /*
//          * Delay focus slightly so the search component has time
//          * to finish opening.
//          */
//         setTimeout(function () {
//           if (
//             $header.hasClass('header--search-expanded') &&
//             $input.length
//           ) {
//             $input.trigger('focus');
//           }
//         }, 50);
//       }
//     }

//     if ($header[0]) {
//       new MutationObserver(function () {
//         syncSearchState();
//       }).observe($header[0], {
//         attributes: true,
//         attributeFilter: ['class']
//       });
//     }

//     if ($searchBar[0]) {
//       new MutationObserver(function () {
//         syncSearchState();
//       }).observe($searchBar[0], {
//         attributes: true,
//         attributeFilter: ['class', 'style', 'hidden']
//       });
//     }

//     $(document).on(
//       'click',
//       '[data-action="toggle-search"]',
//       function () {
//         setTimeout(syncSearchState, 50);
//         setTimeout(syncSearchState, 250);
//       }
//     );

//     syncSearchState();
//   }


//   /* =========================================================
//      ISSUE 13
//      Disclosure labels must reflect expanded/collapsed state
//      ========================================================= */
//   function initDisclosureLabels() {
//     function syncLabel(element) {
//       var $element = $(element);

//       var expanded =
//         $element.attr('aria-expanded') === 'true';

//       var label =
//         $element.attr('aria-label') ||
//         $element.attr('title') ||
//         $.trim($element.text()) ||
//         'menu';

//       label = label.replace(
//         /^(Open|Close|Expand|Collapse)\s+/i,
//         ''
//       );

//       var prefix;

//       if ($element.hasClass('header__mobile-nav-toggle')) {
//         prefix = expanded ? 'Close ' : 'Open ';
//       } else {
//         prefix = expanded ? 'Collapse ' : 'Expand ';
//       }

//       $element.attr('aria-label', prefix + label);
//     }

//     function observeDisclosure(element) {
//       syncLabel(element);

//       new MutationObserver(function () {
//         syncLabel(element);
//       }).observe(element, {
//         attributes: true,
//         attributeFilter: ['aria-expanded']
//       });
//     }

//     $(
//       '.header__mobile-nav-toggle, ' +
//       '.tmenu-a11y-toggle, ' +
//       '.mobile-menu__a11y-toggle'
//     ).each(function () {
//       observeDisclosure(this);
//     });

//     /*
//      * qikify can create disclosure controls dynamically.
//      */
//     $(document).on(
//       'click',
//       '.header__mobile-nav-toggle',
//       function () {
//         setTimeout(function () {
//           $(
//             '.header__mobile-nav-toggle, ' +
//             '.tmenu-a11y-toggle, ' +
//             '.mobile-menu__a11y-toggle'
//           ).each(function () {
//             if (!$(this).data('a11yLabelObserved')) {
//               $(this).data('a11yLabelObserved', true);
//               observeDisclosure(this);
//             }
//           });
//         }, 300);
//       }
//     );
//   }


//   /* =========================================================
//      ISSUE 14
//      Collapsed newsletter panel must not be keyboard reachable
//      ========================================================= */
//   function initNewsletterPanel() {
//     var $panel = $('#announcement-bar-newsletter');
//     var $trigger = $('.announcement-bar__button').first();

//     if (!$panel.length || !$trigger.length) {
//       return;
//     }

//     function syncNewsletter() {
//       var isOpen =
//         $trigger.attr('aria-expanded') === 'true';

//       $panel.attr({
//         'aria-hidden': String(!isOpen)
//       });

//       $panel
//         .find('a, button, input, select, textarea, [tabindex]')
//         .each(function () {
//           var $element = $(this);

//           if (isOpen) {
//             /*
//              * Restore only tabindex values that this script changed.
//              */
//             if ($element.data('a11yOriginalTabindex') !== undefined) {
//               var original =
//                 $element.data('a11yOriginalTabindex');

//               if (original === '') {
//                 $element.removeAttr('tabindex');
//               } else {
//                 $element.attr('tabindex', original);
//               }

//               $element.removeData('a11yOriginalTabindex');
//             }
//           } else {
//             if ($element.data('a11yOriginalTabindex') === undefined) {
//               $element.data(
//                 'a11yOriginalTabindex',
//                 $element.attr('tabindex') || ''
//               );
//             }

//             $element.attr('tabindex', '-1');
//           }
//         });

//       if (
//         !isOpen &&
//         $.contains($panel[0], document.activeElement)
//       ) {
//         $trigger.trigger('focus');
//       }
//     }

//     new MutationObserver(function () {
//       syncNewsletter();
//     }).observe($trigger[0], {
//       attributes: true,
//       attributeFilter: ['aria-expanded']
//     });

//     syncNewsletter();
//   }


//   /* =========================================================
//      ISSUE 15
//      Predictive search combobox/listbox semantics
//      ========================================================= */
//   function initPredictiveSearch() {
//     var $input = $('.search-bar__input').first();
//     var $results = $('.search-bar__results').first();

//     if (!$input.length || !$results.length) {
//       return;
//     }

//     var resultsId = 'search-bar-results';

//     $results.attr({
//       id: resultsId,
//       role: 'listbox',
//       'aria-label': 'Search results'
//     });

//     $input.attr({
//       role: 'combobox',
//       'aria-expanded': 'false',
//       'aria-controls': resultsId,
//       'aria-autocomplete': 'list',
//       'aria-haspopup': 'listbox'
//     });

//     /*
//      * Live region for announcing result availability.
//      */
//     var $status = $('#search-status');

//     if (!$status.length) {
//       $status = $('<div>', {
//         id: 'search-status',
//         'class': 'visually-hidden',
//         role: 'status',
//         'aria-live': 'polite',
//         'aria-atomic': 'true'
//       }).appendTo('body');
//     }

//     var updateTimer;

//     function updateResults() {
//       clearTimeout(updateTimer);

//       updateTimer = setTimeout(function () {
//         /*
//          * Recalculate results because predictive search may
//          * replace the entire result markup.
//          */
//         var $items = $results
//           .find('.search-bar__result-item');

//         var $links = $results
//           .find('.search-bar__result-link');

//         var count = $items.length || $links.length;

//         $results.attr(
//           'aria-hidden',
//           String(count === 0)
//         );

//         $input.attr(
//           'aria-expanded',
//           String(count > 0)
//         );

//         /*
//          * Give every result a unique ID and option semantics.
//          */
//         $links.each(function (index) {
//           var $link = $(this);

//           var optionId =
//             $link.attr('id') ||
//             'search-result-option-' + index;

//           $link.attr({
//             id: optionId,
//             role: 'option'
//           });
//         });

//         if (count > 0) {
//           $status.text(
//             count +
//             ' search result' +
//             (count === 1 ? '' : 's') +
//             ' available.'
//           );
//         } else {
//           $status.text('');
//         }
//       }, 100);
//     }

//     /*
//      * Observe dynamically generated predictive-search results.
//      */
//     new MutationObserver(function () {
//       updateResults();
//     }).observe($results[0], {
//       childList: true,
//       subtree: true
//     });

//     /*
//      * Reset search state when input is cleared.
//      */
//     $input.on('input', function () {
//       if (!$.trim($(this).val())) {
//         $input
//           .attr('aria-expanded', 'false')
//           .removeAttr('aria-activedescendant');

//         $results
//           .attr('aria-hidden', 'true');

//         $status.text('');
//       }
//     });

//     updateResults();
//   }


//   /* =========================================================
//      ISSUE 16
//      Mini-cart quantity field must remain a textbox/input
//      ========================================================= */
//   function fixQuantityFields() {
//     $('.quantity-selector__value[role="status"]').each(function () {
//       var $field = $(this);

//       $field.removeAttr('role');

//       /*
//        * Only add inputmode when the element is an actual input.
//        */
//       if ($field.is('input, textarea')) {
//         $field.attr({
//           inputmode: 'numeric',
//           'aria-label': 'Quantity'
//         });
//       } else {
//         $field.attr('aria-label', 'Quantity');
//       }
//     });
//   }


//   /* =========================================================
//      RUN ALL FIXES
//      ========================================================= */
//   $(function () {
//     injectMobileToggles();
//     fixMegaMenuHeadings();
//     initKeyboardFocus();
//     initSearchEscape();
//     initReviewCarouselKeyboard();
//     fixBrandLogoNames();
//     fixMobileHeroAltText();
//     initSearchToggle();
//     initDisclosureLabels();
//     initNewsletterPanel();
//     initPredictiveSearch();
//     fixQuantityFields();

//     /*
//      * Run again after dynamically loaded Shopify/qikify content.
//      */
//     setTimeout(function () {
//       injectMobileToggles();
//       fixMegaMenuHeadings();
//       fixBrandLogoNames();
//       fixMobileHeroAltText();
//       fixQuantityFields();
//     }, 500);

//     setTimeout(function () {
//       injectMobileToggles();
//       fixMegaMenuHeadings();
//       fixBrandLogoNames();
//       fixMobileHeroAltText();
//       fixQuantityFields();
//     }, 1500);
//   });

//   /*
//    * Shopify/qikify/AJAX content can be inserted after page load.
//    * A lightweight observer ensures accessibility attributes are
//    * restored when those components are re-rendered.
//    */
//   var accessibilityObserver = new MutationObserver(function (mutations) {
//     var shouldRefresh = false;

//     mutations.forEach(function (mutation) {
//       if (
//         mutation.addedNodes &&
//         mutation.addedNodes.length
//       ) {
//         shouldRefresh = true;
//       }
//     });

//     if (!shouldRefresh) {
//       return;
//     }

//     clearTimeout(window.__a11yRefreshTimer);

//     window.__a11yRefreshTimer = setTimeout(function () {
//       injectMobileToggles();
//       fixBrandLogoNames();
//       fixMobileHeroAltText();
//       fixQuantityFields();
//     }, 150);
//   });

//   if (document.body) {
//     accessibilityObserver.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
//   }

// })(jQuery);



    // Issue 4: Mobile menu submenus cannot be opened with a keyboard (CRITICAL)
    jQuery(function ($) {
      function injectMobileToggles() {
        $('#mobile-menu a.tmenu_item_link[aria-haspopup="true"]').each(function (i) {
          var $link = $(this);
          if ($link.data('a11yToggled')) { return; }
          $link.data('a11yToggled', true);

          var $sub = $link.siblings('.tmenu_submenu').first();
          if (!$sub.length) { $sub = $link.parent().find('.tmenu_submenu').first(); }
          if (!$sub.length) { return; }

          var subId = $sub.attr('id') || ('mobile-submenu-' + i);
          $sub.attr('id', subId);

          // The link keeps its href and stops pretending to be a disclosure.
          $link.removeAttr('aria-haspopup aria-expanded');

          $('<button>', {
            type: 'button',
            'class': 'mobile-menu__a11y-toggle',
            'aria-expanded': 'false',
            'aria-controls': subId,
            'aria-label': 'Expand ' + $.trim($link.text()) + ' submenu'
          }).insertAfter($link);
        });
      }

      injectMobileToggles();
      // qikify renders asynchronously — re-run when the drawer is opened.
      $(document).on('click', '.header__mobile-nav-toggle', function () {
        setTimeout(injectMobileToggles, 250);
      });

      $(document).on('click', '.mobile-menu__a11y-toggle', function () {
        var $btn = $(this);
        var open = $btn.attr('aria-expanded') === 'true';
        var name = $btn.attr('aria-label').replace(/^(Expand|Collapse)\s/, '');

        $btn.attr('aria-expanded', String(!open))
            .attr('aria-label', (open ? 'Expand ' : 'Collapse ') + name);
        $('#' + $btn.attr('aria-controls')).toggleClass('is-open', !open);
        // Keep the app's own state in sync so mouse + keyboard agree.
        $btn.prev('a').trigger('tmenu:toggle');
      });
    });

    // Issue 5: Non-functional "column heading" links are in the tab order inside mega menus

    jQuery(function ($) {
      $('.tmenu_submenu a.tmenu_item_link[tmenu-disabled-link], ' +
        '.tmenu_submenu a.tmenu_item_link[href="javascript:;"]').each(function () {
        var $a = $(this);
        $('<div>', {
          'class': $a.attr('class') + ' tmenu_heading',
          role: 'heading',
          'aria-level': '3',
          text: $.trim($a.text())
        }).replaceAll($a);
      });
    });

    // Issue 6: Focus rings on buttons and inputs are suppressed until the user presses Tab
    jQuery(function ($) {
      var pointerDown = false;
      $(document)
        .on('pointerdown mousedown touchstart', function () { pointerDown = true; })
        .on('keydown', function () { pointerDown = false; })
        .on('focusin', function (e) {
          if (!pointerDown) { $('body').addClass('is-tabbing'); }
          $(e.target).toggleClass('is-kbd-focus', !pointerDown);
        })
        .on('focusout', function (e) { $(e.target).removeClass('is-kbd-focus'); });
    });

    // Issue 7: Escape does not dismiss the predictive-search results panel
    jQuery(function ($) {
      $(document).on('keydown', '.search-bar__input, .search-bar__results a', function (e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') { return; }
        e.stopPropagation();
        var $input = $('.search-bar__input');
        $('.search-bar__results').empty().attr('hidden', true);
        $input.attr('aria-expanded', 'false').removeAttr('aria-activedescendant').focus();
      });
    });


    // Issue 8: Space on the review-carousel arrows activates and scrolls the page
    jQuery(function ($) {
      var SEL = '.jdgm-carousel__left-arrow, .jdgm-carousel__right-arrow';
      $(document).on('keydown', SEL, function (e) {
        if (e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 32) {
          e.preventDefault();          // stop the page scroll
          $(this).trigger('click');
        }
      });
    });

    // Issue 10: Seventeen brand-logo links have no accessible name (CRITICAL)
    jQuery(function ($) {
      var SEL = '#tmenu-submenu-5 a, .quick-links__link, .tmenu_submenu a:has(img[alt=""])';

      $(SEL).each(function () {
        var $a = $(this);
        if ($.trim($a.attr('aria-label') || '')) { return; }
        if ($.trim($a.clone().children('style').remove().end().text())) { return; }

        var $img = $a.find('img').first();
        var name = $.trim($img.attr('alt') || '');

        if (!name) {
          var handle = ($a.attr('href') || '').split('?')[0].split('/').filter(Boolean).pop() || '';
          name = handle.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        }
        if (!name) { return; }

        $a.attr('aria-label', 'Shop ' + name);
        $img.attr({ alt: '', role: 'presentation' });
      });
    });

    // Issue 11: Mobile hero banner images have empty alt, losing the offer entirely
    jQuery(function ($) {
      $('.slideshow__slide').each(function () {
        var $slide  = $(this);
        var desktop = $.trim($slide.find('.hidden-phone img').attr('alt') || '');
        var $mobile = $slide.find('.hidden-tablet-and-up img');
        if (desktop && $mobile.length && !$.trim($mobile.attr('alt') || '')) {
          $mobile.attr('alt', desktop);
        }
      });
    });

    // Issue 12: Search toggle reports aria-expanded="false" while the search bar is open
    jQuery(function ($) {
      var $btn    = $('[data-action="toggle-search"]');
      var $header = $('.header');
      var $input  = $('.search-bar__input');

      $btn.attr({ role: 'button', 'aria-controls': 'header-search-bar' });
      $('.search-bar').attr('id', 'header-search-bar');

      function sync() {
        var open = $header.hasClass('header--search-expanded');
        $btn.attr({
          'aria-expanded': String(open),
          'aria-label': open ? 'Close search' : 'Open search'
        });
        if (open) { $input.trigger('focus'); }   // see Issue 26
      }

      new MutationObserver(sync).observe($header[0], {
        attributes: true, attributeFilter: ['class']
      });
      sync();
    });

    // Issue 13: Disclosure labels never change to reflect the expanded state
    jQuery(function ($) {
      function syncLabel(el) {
        var $el  = $(el);
        var open = $el.attr('aria-expanded') === 'true';
        var base = ($el.attr('aria-label') || '').replace(/^(Open|Close|Expand|Collapse)\s+/i, '');
        var verb = $el.hasClass('header__mobile-nav-toggle')
          ? (open ? 'Close ' : 'Open ')
          : (open ? 'Collapse ' : 'Expand ');
        $el.attr('aria-label', verb + base);
      }

      $('.header__mobile-nav-toggle, .tmenu-a11y-toggle').each(function () {
        syncLabel(this);
        new MutationObserver(function (m) { syncLabel(m[0].target); })
          .observe(this, { attributes: true, attributeFilter: ['aria-expanded'] });
      });
    });

    // Issue 14: Collapsed newsletter panel keeps aria-hidden="false" and stays keyboard-reachable [issue here page relaoding]
    jQuery(function ($) {
      var $panel = $('#announcement-bar-newsletter');
      if (!$panel.length) { return; }
      var $trigger = $('.announcement-bar__button');

      function sync() {
        var open = $trigger.attr('aria-expanded') === 'true';
        $panel.attr('aria-hidden', String(!open));
        $panel.find('a, button, input, select, textarea')
              .attr('tabindex', open ? null : '-1');
        if (!open && $.contains($panel[0], document.activeElement)) {
          $trigger.trigger('focus');   // see Issue 25
        }
      }

      new MutationObserver(sync).observe($trigger[0], {
        attributes: true, attributeFilter: ['aria-expanded']
      });
      sync();
    });

    // Issue 15: Predictive search has no combobox semantics and announces nothing
    jQuery(function ($) {
      var $input   = $('.search-bar__input');
      var $results = $('.search-bar__results');
      if (!$input.length || !$results.length) { return; }

      $results.attr({ id: 'search-bar-results', role: 'listbox', 'aria-label': 'Search results' });
      $input.attr({
        role: 'combobox',
        'aria-expanded': 'false',
        'aria-controls': 'search-bar-results',
        'aria-autocomplete': 'list',
        'aria-haspopup': 'listbox'
      });

      if (!$('#search-status').length) {
        $('<div>', { id: 'search-status', 'class': 'visually-hidden',
                     role: 'status', 'aria-live': 'polite', 'aria-atomic': 'true' })
          .appendTo('body');
      }

      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var n = $results.find('.search-bar__result-item').length;
          $input.attr('aria-expanded', String(n > 0));
          $results.find('.search-bar__result-link').attr('role', 'option');
          $('#search-status').text(
            n ? n + ' search result' + (n === 1 ? '' : 's') + ' available. Use Tab to review them.'
              : ''
          );
        }, 350);
      }).observe($results[0], { childList: true, subtree: true });
    });

    // Issue 16: The mini-cart quantity field carries role="status", destroying its textbox role
    jQuery(function ($) {
      $(document).on('DOMNodeInserted cart:refresh', function () {
        $('.quantity-selector__value[role="status"]')
          .removeAttr('role')
          .attr({ inputmode: 'numeric', 'aria-label': 'Quantity' });
      });
      $('.quantity-selector__value[role="status"]').removeAttr('role').attr('aria-label', 'Quantity');
    });




/* Accessible dropdown toggle for the Qikify T-Menu main menu (jQuery 3.x) */



 setTimeout(function(){ 
      //your code

          (function ($) {
              'use strict';
              if (!$) { return; }

              /* ---------------- helpers ---------------- */
              $.fn.cssImportant = function (p, v) {
                  return this.each(function () { this.style.setProperty(p, v, 'important'); });
              };
              $.fn.nativeKey = function (key) {            // the menu app only hears real DOM events
                  return this.each(function () {
                  this.dispatchEvent(new KeyboardEvent('keydown', { key: key, bubbles: true, cancelable: true }));
                  });
              };
              $.fn.focusNoScroll = function () {
                  if (this[0]) { this[0].focus({ preventScroll: true }); }
                  return this;
              };

                



              /* =========================================================
                  2) HOMEPAGE BANNER - play / pause
                  ========================================================= */
              function slideshowA11y() {
                  var $s = $('.slideshow.flickity-enabled').first();
                  if (!$s.length || $s.children('.a11y-slideshow-toggle').length) { return; }
                  var el = $s[0], flkty = null;

                  /* resolve the Flickity instance without hard-coding a bundler global name */
                  for (var k in window) {
                  try {
                      var g = window[k];
                      if (g && typeof g.data === 'function') {
                      var i = g.data(el);
                      if (i && typeof i.playPlayer === 'function') { flkty = i; break; }
                      }
                  } catch (e) {}
                  }

                  if (!$('#a11y-slideshow-css').length) {
                  $('<style>', { id: 'a11y-slideshow-css' }).text(
                      '.slideshow{position:relative}' +
                      '.a11y-slideshow-toggle{position:absolute;right:20px;bottom:20px;z-index:3;width:44px;height:44px;' +
                      'display:flex;align-items:center;justify-content:center;padding:0;border-radius:50%;' +
                      'border:2px solid #fff;background:rgba(0,0,0,.6);color:#fff;cursor:pointer;font:14px/1 sans-serif}' +
                      '.a11y-slideshow-toggle:focus-visible{outline:3px solid #fff;outline-offset:2px}' +
                      '.flickity-page-dots .dot:focus-visible{outline:3px solid #fff;outline-offset:3px}'
                  ).appendTo('head');
                  }

                  var PAUSE = '<span aria-hidden="true">&#10074;&#10074;</span>';
                  var PLAY  = '<span aria-hidden="true">&#9654;</span>';
                  var playing = true;

                  var $btn = $('<button>', {
                  type: 'button',
                  'class': 'a11y-slideshow-toggle',
                  'aria-label': 'Pause banner slideshow',
                  html: PAUSE
                  }).appendTo($s);

                  function setPlaying(next) {
                  playing = next;
                  if (flkty) { playing ? flkty.playPlayer() : flkty.stopPlayer(); }
                  else { el.dispatchEvent(new MouseEvent(playing ? 'mouseleave' : 'mouseenter')); }
                  $btn.attr('aria-label', playing ? 'Pause banner slideshow' : 'Play banner slideshow')
                      .html(playing ? PAUSE : PLAY);
                  }

                  $btn.on('click', function () { setPlaying(!playing); });

                  $s.attr({ role: 'region', 'aria-roledescription': 'carousel', 'aria-label': 'Promotional banners carousel. Use the left and right arrow keys to change slide.' });

                  /* the page dots are <li> - give them button semantics + keyboard operation */
                  $s.find('.flickity-page-dots .dot').each(function (i) {
                  $(this).attr({ role: 'button', tabindex: 0, 'aria-label': 'Go to slide ' + (i + 1) })
                          .on('keydown', function (e) {
                          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $(this).trigger('click'); }
                          });
                  });

                  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { setPlaying(false); }
              }

                  /* =========================================================
                      3) JUDGE.ME REVIEWS - hide clipped slides from AT
                      ========================================================= */
                  function reviewCarouselA11y() {
                      var $c = $('.jdgm-carousel__item-container').first();
                      if (!$c.length || $c.data('a11yDone')) { return; }
                      $c.data('a11yDone', true);

                      function sync() {
                  var box = $c[0].getBoundingClientRect();
                  $c.find('.jdgm-carousel-item').each(function () {
                      var r = this.getBoundingClientRect();
                      var off = r.right <= box.left + 1 || r.left >= box.right - 1;
                      var $i = $(this);
                      if (off === ($i.attr('aria-hidden') === 'true')) { return; }   // idempotent
                      if (off) {
                      $i.attr('aria-hidden', 'true').prop('inert', true)
                          .find('a[href], button, [tabindex]').attr('tabindex', '-1');
                      } else {
                      $i.removeAttr('aria-hidden').prop('inert', false)
                          .find('a[href], button, [tabindex]').removeAttr('tabindex');
                      }
                  });
                  }

                  $(document).on('click keyup', '.jdgm-carousel__left-arrow, .jdgm-carousel__right-arrow',
                  function () { window.setTimeout(sync, 400); });
                  $(window).on('resize', function () { window.setTimeout(sync, 200); });

                  var pending = null;
                  new MutationObserver(function () {
                  if (pending) { return; }
                  pending = window.setTimeout(function () { pending = null; sync(); }, 100);
                  }).observe($c[0], { attributes: true, subtree: true, attributeFilter: ['style', 'class'] });

                  sync();
              }

              $(function () {
                  // megaMenuA11y();
                  slideshowA11y();
                  reviewCarouselA11y();
                  /* both widgets are app-injected and render late */
                  $.each([800, 2000, 4000], function (i, ms) {
                  window.setTimeout(function () { slideshowA11y(); reviewCarouselA11y(); }, ms);
                  });
              });
              })(window.jQuery);



          },

      
2000); 











